var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('general.email'))+":")]),_vm._v(" "),_c('strong',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.currentUserEmail))])]),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('general.first_name'))+":")]),_vm._v(" "),_c('strong',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.currentUserFirstName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }